import { render, staticRenderFns } from "./Developer.vue?vue&type=template&id=f8d29fd0&scoped=true"
import script from "./Developer.vue?vue&type=script&lang=js"
export * from "./Developer.vue?vue&type=script&lang=js"
import style0 from "./Developer.vue?vue&type=style&index=0&id=f8d29fd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d29fd0",
  null
  
)

export default component.exports